const LoadingPage = () => {
    return (
        <div className="loading-page">
            <div className="flex content-center justify-center text-center items-center h-[88vh]">
                <h1 className="text-white text-7xl font-bold">Loading<span className="animate-pulse">...</span></h1>
            </div>
        </div>
    );
}

export default LoadingPage;
